<template>
  <div class="p-3 flex" :class="`${bgColour} ${textColour}`">
    <div class="flex-shrink pr-3">
      <i class="fas fa-fw" :class="icon"></i>
    </div>
    <div class="flex-grow">
      {{ message }}

      <ul v-if="list.length" class="text-gray-600 text-sm mt-2 list-disc ml-6">
        <li v-for="(item, i) in list" :key="i">{{ item }}</li>
      </ul>

      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String
    },
    list: {
      type: Array,
      default: function () {
        return []
      }
    },
    bgColour: {
      type: String,
      default: 'bg-gray-300'
    },
    textColour: {
      type: String,
      default: 'text-black'
    },
    icon: {
      type: String,
      default: 'fa-info-circle'
    }
  }
}
</script>
